<template>
  <div>
    <spacer :y="5"/>
    <ul>
      <stack-item>
        <contents-box :title="title" v-if="reserve && helper">
          <user-box :showId="true" type="inner" :user="reserve.fromUser">
            <template v-slot:main>
              <div>
                <spacer :y="3"/>
                <ul :class="$style.detail">
                  <li>
                    <label-box label="実施日" color="gray" size="sm" :class="$style.userlabel"/>
                    <p :class="$style.content">{{ formatTimestamp(reserve.schedule.date, 'YYYY/MM/DD HH:00') }}</p>
                  </li>
                  <li>
                    <label-box label="お悩み" color="gray" size="sm" :class="$style.userlabel"/>
                    <p :class="$style.content">
                      <span
                        v-for="r_type in sortWorryTypes(reserve.type)"
                        :key="r_type"
                        :class="[$style.types, hasSubTypesRecorded(reserve) ? $style.typesCompany : '']">{{ getWorryTypeLabel(r_type, isCompany, 'reserve') }}<span v-if="reserve.other_text && r_type === 6">（{{ reserve.other_text }}）</span>
                        <span v-if="getWorrySelectedSubText(r_type, getRecordedSubs(reserve, r_type), isCorporate, 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(r_type, getRecordedSubs(reserve, r_type), isCorporate, 'reserve') }}</span>
                      </span>
                    </p>
                  </li>
                  <li class="n2br">
                    <label-box label="相談内容" color="gray" size="sm" :class="$style.userlabel"/>
                    <p
                      :class="$style.content"
                      v-if="reserve.memos.customer[0]"
                      v-html="reserve.memos.customer[0].memo"></p>
                  </li>
                  <li>
                    <label-box label="ココモニ" color="gray" size="sm" :class="$style.userlabel"/>
                    <div :class="$style.content">
                      <ul :class="$style.who5">
                        <li v-for="(item, i) in helper.master.who5.items" :key="item">
                          <p>{{ item.label }}</p>
                          <p>{{ helper.master.who5.labels[reserve.who5Answer.answers[i]] }}</p>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li class="n2br">
                    <label-box :label="isCompany ? '企業コメント' : '学校コメント'" color="gray" size="sm" :class="$style.userlabel"/>
                    <p
                      :class="$style.content"
                      v-if="reserve.memos.teacher[0]"
                      v-html="reserve.memos.teacher[0].memo"></p>
                    <p v-if="!reserve.memos.teacher[0]">記入なし</p>
                  </li>
                </ul>
                <spacer :y="2"/>
                <contents-box title="カルテ" type="inner">
                  <spacer :y="1"/>
                  <div
                  :class="$style.textareaDiv"
                  :flag="flag.memo">
                  <textarea
                    name="memo"
                    id="memo"
                    :rows="kartePlaceholder.rows"
                    :value="memo"
                    v-on:input="updateMemo"
                    :class="$style.textarea">
                  </textarea>
                  <!-- 注釈は 1 行で書く（改行・インデントが multilineText の pre-wrap で描画されるため）。
                       カルテ欄は li.n2br の傘の外なので、改行保持は multilineText を自前で付ける。 -->
                  <div
                  id="placeholderDiv"
                  v-if="!flag.memo"
                  :class="$style.placeholderDiv"
                  class="multilineText">{{ kartePlaceholder.note }}</div>
                </div>
                  <p :class="$style.assistant">※保存せずにページを離れると入力した内容は失われます。編集した場合は、忘れずに更新ボタンを押してください。</p>
                  <spacer :y="2"/>
                  <btn-container>
                    <basic-btn tag="button" v-on:click="registMemo">更新</basic-btn>
                  </btn-container>
                </contents-box>
              </div>
            </template>
          </user-box>
        </contents-box>
      </stack-item>

      <stack-item>
        <contents-box :title="reportBoxTitle" id="confirm" v-if="reserve && helper">
          <!-- 注釈は 1 行で書く（改行・インデントが multilineText の pre-wrap で描画されるため）。
               赤字・枠囲みの警告トーンは採らない（指示書の赤枠は指示書側の注記表現）。 -->
          <p
            v-if="headerNotice"
            :class="$style.headerNotice"
            class="multilineText">{{ headerNotice }}</p>
          <ul :class="$style.labellist">
            <li v-if="reserve.fromUser">
              <spacer :y="1"/>
              <div :class="$style.labels" >
                <label-box label="ID" color="gray" size="sm" :class="$style.userlabel"/>
                <p :class="$style.content">{{ reserve.fromUser.customer_id }}</p>
                <spacer :x="3"/>
                <label-box label="性別" color="gray" size="sm" :class="$style.userlabel"/>
                <p :class="$style.content">{{ helper.master.labels.users.gender[reserve.fromUser.gender] }}</p>
                <spacer :x="3"/>
                <label-box label="年齢" color="gray" size="sm" :class="$style.userlabel"/>
                <p :class="$style.content">{{ reserve.customer_age || reserve.fromUser.age }}歳</p>
              </div>
            </li>
            <li class="n2br">
              <label-box label="相談概要" :color="reportLabelColor" :class="$style.label"/>
              <spacer :y="2"/>
              <div
                :class="[$style.textareaDiv, $style.noteField]"
                v-if="!flag.isConfirm">
                <textarea
                  name="summary"
                  id="summary"
                  :rows="reportNotes.summary.rows"
                  :value="summary"
                  v-on:input="summary = $event.target.value"
                  :class="$style.textarea"></textarea>
                <!-- 注釈は 1 行で書く（親に white-space: pre-wrap が効くため、改行・インデントが空白として描画される） -->
                <div v-if="!summary" :class="$style.placeholderDiv">{{ reportNotes.summary.note }}</div>
              </div>
              <p v-if="flag.isConfirm">{{ summary }}</p>
            </li>
            <li class="n2br">
              <label-box label="医学的所見に関する特記事項" :color="reportLabelColor" :class="$style.label"/>
              <spacer :y="2"/>
              <div
                :class="[$style.textareaDiv, $style.noteField]"
                v-if="!flag.isConfirm">
                <textarea
                  name="notice"
                  id="notice"
                  :rows="reportNotes.notice.rows"
                  :value="notice"
                  v-on:input="notice = $event.target.value"
                  :class="$style.textarea"></textarea>
                <div v-if="!notice" :class="$style.placeholderDiv">{{ reportNotes.notice.note }}</div>
              </div>
              <p v-if="flag.isConfirm">{{ notice }}</p>
            </li>
            <li v-for="(row, i) in radios" :key="row">
              <label-box :label="row.label" :color="reportLabelColor" :class="$style.label"/>
              <div v-if="!flag.isConfirm">
                <div :class="$style.radio_wrap">
                  <div
                    :class="$style.radio"
                    v-for="item in row.items"
                    :key="item">
                    <input
                      type="radio"
                      :id="item.name"
                      :name="row.name"
                      :class="$style.hidden"
                      :checked="row.value === item.value"
                      v-on:click="changeValue('radios', item.value, i)">
                    <label
                      :for="item.name"
                      :class="row.value === item.value ? `${$style.selectlabel} ${$style.checked}` : `${$style.selectlabel}`">{{ item.label }}</label>
                  </div>
                </div>
                <spacer :y="1"/>
                <input
                  v-if="row.name === 'finding'"
                  type="text"
                  :class="$style.text"
                  :placeholder="reportNotes.finding.note"
                  v-model="row.text">
              </div>
              <div v-if="flag.isConfirm">
                <spacer :y="2"/>
                <div v-for="item in row.items" :key="item">
                  <p v-if="item.value === row.value">{{ item.label }}<span v-if="row.value === 1 && row.name === 'finding'">（{{ row.text }}）</span></p>
                </div>
              </div>
            </li>
            <li>
              <label-box label="指導区分・指導期間" :color="reportLabelColor" :class="$style.label"/>
              <div v-if="!flag.isConfirm">
                <div :class="$style.radio_wrap">
                  <div
                    :class="$style.radio"
                    v-for="(row, k) in checks" :key="row">
                    <input
                      v-if="k !== 'medical_cooperation' || user.account_type === 21"
                      type="radio"
                      :id="`type_${k}`"
                      name="supportType"
                      :class="$style.hidden"
                      v-on:change="updateSupportType(k)">
                    <label
                      :for="`type_${k}`"
                      v-if="k !== 'medical_cooperation' || user.account_type === 21"
                      :class="k === supportType ? `${$style.selectlabel} ${$style.checked}` : `${$style.selectlabel}`">{{ row.label }}</label>
                  </div>
                </div>
                <p :class="$style.support_label" v-if="supportType && supportType !== 'medical_cooperation'">指導期間を選択してください。</p>
                <div v-if="supportType && supportType !== 'medical_cooperation'">
                  <div :class="$style.radio_wrap">
                    <div
                      :class="$style.radio"
                      v-for="item in checks[supportType].items"
                      :key="item">
                      <input
                        type="radio"
                        :id="`${supportType}-${item.value}`"
                        :name="supportType"
                        :class="$style.hidden"
                        :checked="checks[supportType].value === item.value"
                        v-on:change="changeValue('checks', item.value, null)">
                      <label
                        :for="`${supportType}-${item.value}`"
                        :class="checks[supportType].value === item.value ? `${$style.selectlabel} ${$style.checked}` : `${$style.selectlabel}`">{{ item.label }}</label>
                    </div>
                  </div>
                  <spacer :y="2"/>
                  <input
                    :class="$style.text"
                    placeholder="その他を選択した場合こちらに入力してください。"
                    type="text"
                    v-model="checks[supportType].text">
                </div>
              </div>
              <div v-if="flag.isConfirm">
                <spacer :y="2"/>
                <p>{{ checks[supportType].label }}</p>
                <p v-for="item in checks[supportType].items" :key="item">
                  <span v-if="checks[supportType].value === item.value">{{ item.label }}</span>
                  <span v-if="checks[supportType].value === item.value && item.value === checks[supportType].needText">（{{ checks[supportType].text }}）</span></p>
              </div>
            </li>
            <li v-if="user.account_type === 21">
              <label-box
                label="暫定診断 ICD-11"
                :color="reportLabelColor"
                :class="$style.label"/><!--診断は医師のみにしか表示しない-->
              <spacer :y="2"/>
              <select
                :class="$style.select_box"
                name="diagnosis_category"
                id="diagnosis_category"
                @change="updateDiagnosis()"
                v-model="diagnosis.rough">
                <option :value="0" :selected="diagnosis.rough === 0">分類</option>
                <option
                  v-for="n of symptomsList"
                  :value="n"
                  :key="n">{{ n.label }}</option>
              </select><br>
              <spacer :y="2"/>
              <select
                :class="$style.select_box"
                name="diagnosis_deteil"
                id="diagnosis_detail"
                v-model="diagnosis.detail_value">
                <option :value="0" :selected="diagnosis.detail_value === 0">病名</option>
                <option
                  v-for="n of diagnosis.detail_menu" :key="n"
                  :value="n.value">{{ n.label }}</option>
              </select>

            </li>
            <li class="n2br">
              <label-box label="対応・予約に関して" :color="reportLabelColor" :class="$style.label"/>
              <spacer :y="2"/>
              <div
                :class="[$style.textareaDiv, $style.noteField]"
                v-if="!flag.isConfirm">
                <textarea
                  name="report_memo"
                  id="report_memo"
                  :rows="reportNotes.action.rows"
                  :value="report_memo"
                  v-on:input="report_memo = $event.target.value"
                  :class="$style.textarea"></textarea>
                <div v-if="!report_memo" :class="$style.placeholderDiv">{{ reportNotes.action.note }}</div>
              </div>
              <p v-if="flag.isConfirm">{{ report_memo }}</p>
            </li>
          </ul>
          <spacer :y="4"/>
          <btn-container>
            <basic-btn
              tag="button"
              v-if="!flag.isConfirm"
              v-on:click="regist(2);">下書き保存</basic-btn>
            <basic-btn
              tag="button"
              v-if="flag.isConfirm"
              v-on:click="regist(1);">確定</basic-btn>
            <spacer :x="2"/>
            <basic-btn
              tag="button"
              v-if="!flag.isConfirm"
              v-on:click="changeFlag">確認する</basic-btn>
            <basic-btn
              tag="button"
              type="bdr"
              v-if="flag.isConfirm"
              v-on:click="changeFlag">編集画面に戻る</basic-btn>
          </btn-container>
        </contents-box>
      </stack-item>
    </ul>
    <spacer :y="5"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import StackItem from '@/views/components/StackItem.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import UserBox from '@/views/components/UserBox.vue';
import LabelBox from '@/views/components/LabelBox.vue';
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions.js';
import corporateSchool from '@/mixins/corporateSchool.js';
import { KARTE_NOTE_SCHOOL, KARTE_NOTE_CORPORATE } from '@/constants/counselorKarte.js';

// 報告書の注釈（プレースホルダ）文言。出典: 企業サイト修正指示書 260817 P7（学校向け）・P8（企業向け）。
// 指示書と 1 行ずつ突き合わせられるよう配列で保持し、join('\n') で改行を復元する。
// 描画は textarea に重ねた .placeholderDiv で、textarea の高さとは連動しない
// ＝ 文言を増減したら computed reportNotes の rows も対で見直すこと（あふれた分は見切れる）。
const NOTE_SUMMARY_SCHOOL = [
  '相談概要は短く簡潔に。主語は利用者本人（テキスト量の目安：2行程度）',
  '【例】小さい頃から家族の言葉で傷つき気持ちが休まらない。遠方の大学に進学したいが、気力が湧かず、受験勉強に集中できない。焦りや将来への不安が大きい。',
].join('\n');

const NOTE_NOTICE = [
  '【例】[医療情報]通院・入院履歴/診断名（本人の診断名把握の有無）/通院状況/次の診察日/服用など',
  '[体調・症状]希死念慮/社交場面における不安/情動/気分の落ち込み/訴えの一貫性/衝動制御/拡大解釈/パニック発作など',
  '*更新情報は日付も入力',
  '*特記事項がない場合は「特になし」と入力',
].join('\n');

const NOTE_FINDING = '「所見あり」を選択した場合は詳細をご入力ください';

const NOTE_ACTION_SCHOOL = [
  '導入校との連携のため、一般の方にも分かりやすいよう、丁寧かつ現実的なコンサルテーションや評価、医学的助言（医師相談）の記載をお願いします（6行程度）',
  '【例】',
  '利用者の“悩み”や“不安”に関する訴え/ご相談の内容に関して利用者本人にフィードバックされたコメントや提案/学校管理者へのアドバイスや注意すべき点/次回相談（継続予定有無）など',
  '',
  '＜表記統一＞',
  'Welcome to talk→ Wtt/担当専門家→当医師、当心理士',
  '＜連絡事項＞学生証の失念/保護者同席/WiFiトラブル/カメラオフ希望/声が出せずチャット相談への切替など',
  '＜NG＞',
  '固有名詞（通院医療機関など）や氏名は書かない。＜カルテ＞に記載（×さくらメンタルクリニック ×鈴木）',
  '但し、医師から提案した医療機関名を除く。',
].join('\n');

// 企業向け（P8）。❷❸ は P8 が P7 を参照しているため学校向けと同文＝定数も共用する。
const NOTE_SUMMARY_CORPORATE = [
  '相談概要は短く簡潔に。主語は利用者本人（テキスト量の目安：2行程度）',
  '【例】職場で求められることや程度の把握が苦手。仕事の優先順位の決め方、同僚や上司とコミュニケーションを取るときの話題の選び方、平静な精神状態の保ち方について考えていきたい。',
].join('\n');

// 学校向けとの差分は 3 点: 冒頭「導入校との連携のため、」なし／「学校管理者への」→「企業側への」／
// 連絡事項「学生証の失念/保護者同席」→「社員証の失念/利用者本人以外の同席」。
const NOTE_ACTION_CORPORATE = [
  '一般の方にも分かりやすいよう、丁寧かつ現実的なコンサルテーションや評価、医学的助言（医師相談）の記載をお願いします（6行程度）',
  '【例】',
  '利用者の“悩み”や“不安”に関する訴え/ご相談の内容に関して利用者本人にフィードバックされたコメントや提案/企業側へのアドバイスや注意すべき点/次回相談（継続予定有無）など',
  '',
  '＜表記統一＞',
  'Welcome to talk→ Wtt/担当専門家→当医師、当心理士',
  '＜連絡事項＞社員証の失念/利用者本人以外の同席/WiFiトラブル/カメラオフ希望/声が出せずチャット相談への切替など',
  '＜NG＞',
  '固有名詞（通院医療機関など）や氏名は書かない。＜カルテ＞に記載（×さくらメンタルクリニック ×鈴木）',
  '但し、医師から提案した医療機関名を除く。',
].join('\n');

// 企業向けのヘッダー注記とタイトル（指示書 P8・報告書ボックスの見出し直下）。
// 1 行目のタイトルと 2〜3 行目の注記は原本では 1 ブロックだが、実装では
// タイトル＝contents-box の title prop・注記＝slot 先頭の段落と描画先が分かれる。
const TITLE_CORPORATE = '報告書（企業向け）';

const NOTE_HEADER_CORPORATE = [
  '企業管理者宛に投函されませんが、利用状況レポートの元資料となります。通常の報告書と同様にご作成をお願いします。',
  'リスク高のご相談はリスク申請をご手配ください。',
].join('\n');

export default {
  name: 'report',
  mixins: [cf, corporateSchool],
  components: {
    StackItem,
    ContentsBox,
    UserBox,
    LabelBox,
    Spacer,
    BasicBtn,
    BtnContainer,
  },
  data() {
    return {
      flag: {
        isConfirm: false,
        memo: true,
        sendFlag: false,
      },
      memo: null,
      reportId: null,
      diagnosisId: null,
      reserveId: null,
      reserve: null,
      notice: null,
      summary: null,
      supportType: null,
      report_memo: null,
      diagnosis: {
        rough: 0,
        detail_menu: null,
        category_value: 0,
        detail_value: 0,
      },
      symptomsList: [],
      radios: [
        {
          name: 'finding',
          label: 'その他の心身の状況',
          value: 0,
          items: [
            {
              label: '所見なし',
              name: 'notFound',
              value: 0,
            },
            {
              label: '所見あり',
              name: 'found',
              value: 1,
            },
          ],
          text: null,
        },
        {
          name: 'cause',
          label: '要因',
          value: 0,
          items: [
            {
              label: '医学的要因（病気・障害等の疑い）',
              name: 'medical',
              value: 1,
            },
            {
              label: '心理社会・環境的要因（友人・家族など）',
              name: 'environmental',
              value: 2,
            },
          ],
        },
      ],
      checks: {
        observe: {
          name: 'observe',
          label: '健康観察',
          value: 0,
          text: null,
          needText: 3,
          items: [
            {
              label: '１ヶ月程度',
              value: 1,
            },
            {
              label: '３ヶ月程度',
              value: 2,
            },
            {
              label: 'その他',
              value: 3,
            },
          ],
        },
        re_counseling: {
          name: 're_counseling',
          label: 'カウンセリング',
          value: 0,
          text: null,
          needText: 3,
          items: [
            {
              label: '２週間後',
              value: 1,
            },
            {
              label: '１ヶ月後',
              value: 2,
            },
            {
              label: 'その他',
              value: 3,
            },
          ],
        },
        re_online: {
          name: 're_online',
          label: '健康相談',
          value: 0,
          text: null,
          needText: 3,
          items: [
            {
              label: '２週間後',
              value: 1,
            },
            {
              label: '１ヶ月後',
              value: 2,
            },
            {
              label: 'その他',
              value: 3,
            },
          ],
        },
        medical_cooperation: {
          name: 'medecal_cooperation',
          label: '医療連携',
          value: 1,
          text: null,
        },
      },
    };
  },
  created() {
    this.reserveId = Number(this.$route.params.slug);
    this.getReserve();
    if (this.user.email) {
      this.setsymptoms();
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'helper/putMaster') {
          this.setsymptoms();
        }
      });
    }
  },
  computed: {
    ...mapState(['user', 'helper']),
    isCompany() {
      return Boolean(this.reserve && this.reserve.fromUser && this.reserve.fromUser.school.length && this.reserve.fromUser.school[0].is_company);
    },
    // 企業固有のお悩みサブ項目ゲート専用（インターン id=18 では false）。ラベル(#3238)は isCompany 据え置き。
    isCorporate() {
      return this.isCorporateSchool(this.reserve?.fromUser?.school);
    },
    // 報告書 4 欄の注釈文言と textarea の行数。企業/学校の出し分けはここへ集約する
    // （文言そのものは script 冒頭の定数）。注釈はオーバーレイ描画で textarea の高さと
    // 連動しない（しかも textarea は UA 既定の line-height: normal で 1 行が注釈の 1 行より低い）
    // ため、note を増減したら rows も対で実測し直すこと。あふれた分は overflow: hidden で見切れる。
    // rows は幅 976px（main-contents 1040px - contents-box padding）で全文が収まる実測値に
    // 1 行分の余裕を足した値（webfont の読込差で行数が 1 行ぶれても切れないようにする）。
    reportNotes() {
      // ❹ だけ 3 分岐。isCorporate（厳密企業）から先に判定するのが要。isCompany は
      // インターン組織を含む広い軸で、そこは現行の短文・現行の rows を維持する
      // （学校向け長文の「導入校・学生証」も企業向け長文の「社員証」もインターンには合わない）。
      let action = { note: NOTE_ACTION_SCHOOL, rows: 17 };
      if (this.isCorporate) {
        action = { note: NOTE_ACTION_CORPORATE, rows: 17 };
      } else if (this.isCompany) {
        action = { note: '企業関係者対応・次回予約に関して何かあれば入力してください。', rows: 5 };
      }
      return {
        // ❶ は学校/企業で文言が違うが、どちらも現行の rows=5 に収まる（＝入力欄の高さは現行と同じ）
        summary: this.isCorporate
          ? { note: NOTE_SUMMARY_CORPORATE, rows: 5 }
          : { note: NOTE_SUMMARY_SCHOOL, rows: 5 },
        notice: { note: NOTE_NOTICE, rows: 6 }, // 現行 5 では注釈がちょうど収まらない（実測）
        finding: { note: NOTE_FINDING }, // ❸ は 1 行 input のため rows なし
        action,
      };
    },
    // 企業版の注釈（16 行）は現行 rows では収まらないため、区分ごとに行数も出し分ける。
    // rows は Chromium / Firefox の実測（企業 16 行 → 22 行必要）に 1 行の余裕を足した値。
    // 版の選択は isCompany（非学校＝インターン・企業）軸。History.vue と同じ根拠で rows を持つ
    // （企業版 16 行 → 23／学校版 17 行 → 24。いずれも必要最小 + 1 行）。
    kartePlaceholder() {
      return this.isCompany
        ? { note: KARTE_NOTE_CORPORATE, rows: 23 }
        : { note: KARTE_NOTE_SCHOOL, rows: 24 };
    },
    // 企業向け雛形は枠色を反転させる（指示書 P8）。適用面はラベルチップ全件とタイトルで、
    // gray チップ（ID/性別/年齢/企業・学校コメント）は対象外。
    // 「暫定診断 ICD-11」チップは当初、指示書の赤点線に含まれないため対象外としていたが、
    // 赤点線は心理士の画面を撮ったスクリーンショットに引かれており、医師にしか描画されない
    // 当該チップはそもそも写っていなかった（＝除外は撮影ロール由来で、意図された除外ではない）。
    // 医師の画面で 1 個だけオレンジが残るため、他のチップに合わせて青にする。
    // props の default は undefined のときしか効かないため、null でなく 2 値を明示して返す。
    reportLabelColor() {
      return this.isCorporate ? 'blue' : 'orange';
    },
    reportBoxTitle() {
      return this.isCorporate ? TITLE_CORPORATE : '報告書';
    },
    // ヘッダー注記は「企業管理者宛に投函されません」という事実主張なので、
    // その挙動を入れる #3353（PR #3358）と同じ厳密企業軸（isCorporate）でゲートする。
    // isCompany（インターン組織を含む広い軸）で出すと事実に反する表示になる。
    headerNotice() {
      return this.isCorporate ? NOTE_HEADER_CORPORATE : null;
    },
    isVirtual() {
      if (!this.reserve || !this.reserve._counselingType) { // まだ情報が取得できないタイミングへの対処
        return false;
      }
      return this.reserve._counselingType.counseling_type === 3;
    },
    title() {
      const prefix = this.isVirtual ? 'バーチャル' : 'オンライン';
      return `${prefix}健康相談内容`;
    },
  },
  methods: {
    updateDiagnosis() {
      this.diagnosis.detail_menu = this.diagnosis.rough.detail;
      this.diagnosis.category_value = this.diagnosis.rough.value;
      // 症名が選択された状態で症群の変更があったら選択解除
      if (this.diagnosis.detail_value !== 0) {
        this.diagnosis.detail_value = 0;
      }
    },
    setsymptoms() {
      this.symptomsList = this.helper.master.symptoms;
    },
    getReserve() {
      const params = {
        id: this.reserveId,
      };
      this.axios({
        method: 'GET',
        url: '/v1/reserve/get/detail',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.reserve = res.reserve;
          if (this.reserve.memos.counselor[0]) this.memo = this.reserve.memos.counselor[0].memo;
          if (!this.memo) {
            this.flag.memo = false;
          } else if (this.memo) {
            this.flag.memo = true;
          }
          if (this.reserve.report) this.setReportItem();
          // 下書きでdiagnosisが選択済みで書き込みをおこなってるのが医師ならserectboxに反映
          if (this.user.account_type === 21 && this.reserve.diagnosis.category !== 0) {
            this.diagnosis.rough = this.symptomsList[this.reserve.diagnosis.category - 1];
            this.diagnosis.detail_menu = this.diagnosis.rough.detail;
            this.diagnosis.category_value = this.diagnosis.rough.value;
            this.diagnosis.detail_value = this.diagnosis.rough.detail[this.reserve.diagnosis.diagnosis - 1].value;
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },
    setReportItem() {
      const report = this.reserve.report;
      if (report.flag === 999) return; // flag = 999は除外
      this.reportId = report.id;
      if (this.user.account_type === 21 && this.reserve.diagnosis) {
        this.diagnosisId = this.reserve.diagnosis.id;
      }
      this.summary = report.summary;
      this.notice = report.notice;
      this.medical_cooperation = report.medical_cooperation;
      this.report_memo = report.report_memo;
      this.radios.forEach((row) => {
        row.value = report[row.name];
        row.text = report[`${row.name}_memo`];
      });
      Object.keys(this.checks).forEach((key) => {
        this.checks[key].value = key === 'medical_cooperation' ? 1 : report[key];
        if (key !== 'medical_cooperation') {
          this.checks[key].text = report[`${key}_memo`];
        }
        if (report[key] !== 0) this.supportType = key;
      });
    },
    changeValue(type, value, idx) {
      if (type === 'radios') {
        this[type][idx].value = value;
      } else {
        this[type][this.supportType].value = value;
      }
    },
    updateCheck(e) {
      this[e.target.id] = e.target.checked ? 1 : 0;
    },
    updateSupportType(name) {
      this.supportType = name;
      Object.keys(this.checks).forEach((key) => {
        if (key !== name) {
          this.checks[key].value = key === 'medical_cooperation' ? 1 : 0;
          if (key === 'medical_cooperation') this.checks[name].text = null;
        }
      });
    },
    changeFlag() {
      if (this.summary === null || this.summary === '') {
        alert('相談概要を入力してください。');
        return;
      }
      if (this.notice === null || this.notice === '') {
        alert('医学的所見に関する特記事項を入力してください、');
        return;
      }
      if (this.report_memo === null || this.report_memo === '') {
        alert('対応・予約に関してを入力してください、');
        return;
      }
      if ((this.diagnosis.category_value === 0 || this.diagnosis.detail_value === 0) && this.user.account_type === 21) {
        alert('暫定診断 ICD-11を選択してください');
        return;
      }
      let invalid = false;
      this.radios.forEach((row) => {
        if (row.name === 'cause' && row.value === 0) {
          invalid = true;
        } else if (row.name === 'finding' && row.value === 1 && (row.text === null || row.text === '')) {
          invalid = true;
        }
      });
      if (invalid) {
        alert('未入力の項目があります。');
        return;
      }

      if (!this.supportType) {
        alert('指導区分を選択してください。');
        return;
      }
      if (this.checks[this.supportType].value === 0) {
        alert('指導期間を選択してください。');
        return;
      }
      if (this.checks[this.supportType].value === this.checks[this.supportType].needText
        && (!this.checks[this.supportType].text || this.checks[this.supportType].text === '')) {
        alert('指導期間でその他を選択した場合、テキストエリアに詳細を記入してください。');
        return;
      }
      // 必須項目が入力されていたら進む
      this.flag.isConfirm = !this.flag.isConfirm;
      if (this.flag.isConfirm) {
        const elem = document.getElementById('confirm');
        const position = elem.getBoundingClientRect().top;
        scrollBy(0, position - 77);
      }
    },
    // reserveReportの登録、diagnosisの登録とは分けている。下書き保存の時はn=2、本登録の時はn=1
    regist(n) {
      const data = {
        flag: n,
        reserve_id: this.reserve.id,
        user_id: this.user.id,
        summary: this.summary,
        notice: this.notice,
        medical_cooperation: this.medical_cooperation,
        report_memo: this.report_memo,
      };

      // 報告書を本登録した相談をにstoreの報告書未記入から削除
      if (n === 1 && this.user.counseling.counselor.reserve.report) { // 報告書記入画面でリロードが走ったときはstoreが空になるので除外
        const targetIndex = this.user.counseling.counselor.reserve.report.findIndex((elem) => elem.id === this.reserve.id);
        this.user.counseling.counselor.reserve.report.splice(targetIndex, 1);
      }

      if (this.reportId) data.id = this.reportId;

      this.radios.forEach((row) => {
        data[row.name] = row.value;
        if (row.name === 'finding') data[`${row.name}_memo`] = row.text;
      });

      Object.keys(this.checks).forEach((key) => {
        if (this.supportType === key) {
          data[key] = this.checks[key].value;
          if (key !== 'medical_cooperation') data[`${key}_memo`] = this.checks[key].text;
        } else {
          data[key] = 0;
          if (key !== 'medical_cooperation') data[`${key}_memo`] = null;
        }
      });

      const endpoint = this.reportId ? 'updater' : 'register';

      this.axios({
        method: 'POST',
        url: `/v1/reserve/report/set/${endpoint}`,
        data,
      })
        .then((response) => {
          let label = '';
          if (n === 1) label = '本登録';
          else if (endpoint === 'register') label = '下書きの登録';
          else label = '下書きの更新';
          alert(`報告書の${label}が完了しました。`);
          this.$store.dispatch('user/counseling/getCounseling');
          // 連絡(下書きは除く)
          if (data.flag === 1 && !this.sendFlag) { // sendFlagは連絡が重複されて行われるのを防ぐため
            this.onlineCounselingContact(response.data.reportID);
          }
          const tab = this.isVirtual ? 'virtual' : 'online';
          this.$router.push(`/counselor/?tab=${tab}`);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });

      if (this.user.account_type === 21) { // 医師は報告書に暫定診断を記入
        this.registDiagnosis(n);
      }
    },

    registDiagnosis(n) {
      const data = {
        flag: n,
        reserve_id: this.reserve.id,
        category: this.diagnosis.category_value,
        diagnosis: this.diagnosis.detail_value,
      };

      if (this.diagnosisId) data.id = this.diagnosisId;

      const endpoint = this.reportId ? 'updater' : 'register';

      this.axios({
        method: 'POST',
        url: `/v1/diagnosis/set/${endpoint}`,
        data,
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    /** オンライン健康相談の連絡 */
    onlineCounselingContact(reportId) {
      this.sendFlag = true;
      // 学校管理者（と事務局）へ連絡
      this.axios({
        method: 'POST',
        url: '/v1/contact/report/online/teacher',
        data: { report_id: reportId },
      })
        .then((response) => {
          console.log(response.data.status);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });

      // 心理士へ連絡
      this.axios({
        method: 'POST',
        url: '/v1/contact/report/online/counselor',
        data: { report_id: reportId },
      })
        .then((response) => {
          console.log(response.data.status);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },
    updateMemo(e) {
      this.memo = e.target.value;
      if (this.memo) {
        this.flag.memo = true;
      } else if (!this.memo) {
        this.flag.memo = false;
      }
    },
    registMemo() {
      const data = {
        reserve_id: this.reserve.id,
        memo: this.memo,
        user_id: this.user.id,
      };

      if (this.reserve.memos.counselor[0]) data.id = this.reserve.memos.counselor[0].id;
      else data.id = null;

      const endpoint = data.id ? 'updater' : 'register';

      this.axios({
        method: 'POST',
        url: `/v1/reserve/memo/set/${endpoint}`,
        data,
      })
        .then(() => {
          alert('カルテを保存しました。');
          this.getReserve();
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" module>
.select_box {
  min-width: 270px;
  padding: 13px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  border-radius: 8px;
  appearance: none;
}
// 企業向け報告書のヘッダー注記（見出し直下）。本文 16px より一段落として 14px にし、
// 下の入力欄群とは margin で切る（この 1 ブロックのためだけに spacer を挟まない）。
.headerNotice {
  font-size: 14px;
  margin-bottom: 24px;
}
.labellist {
  li {
    &:not(:last-child) {
      padding-bottom: 32px;
    }
    .support {
      margin-top: 10px;
      &_label {
        font-size: 14px;
        margin-top: 20px;
      }
      li {
        &:not(:last-child) {
          padding-bottom: 0;
        }
      }
    }
  }
}
.label {
  width: 250px;
}
.labels {
  display: flex;
  align-items: flex-start;
}
.textarea {
  width: 100%;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  padding: 20px;
  border-radius: 8px;
}
.text {
  background-color: var(--gray-sub);
  padding: 13px;
  outline: none;
  border: none;
  border-radius: 8px;
  width: 100%;
}
.hidden {
  display: none;
}
.radios {
  li {
    padding: 20px 0;
    border-bottom: 1px solid var(--gray-main);
  }
}
.radio {
  margin-top: 10px;
  &_wrap {
    display: flex;
  }
  &:not(:last-child) {
    margin-right: 20px;
  }
}
.selectlabel {
  display: inline-block;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #999;
  color: #999;
  // border: 1px solid var(--black);
  // color: var(--black);

  &.checked {
    background-color: var(--blue-main);
    border-color: var(--blue-main);
    color: #fff;
  }
}
.userlabel {
  width: 100px;
  margin-right: 20px;
}
.detail {
  li {
    display: flex;
    align-items: flex-start;
    .content {
      font-size: 14px;
      margin-top: 3px;
      flex: 1;
    }
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}
.types {
  margin-right: 20px;
  // 「その他」自由記述などで長い半角英字連続が来た時の折り返し（#3244）
  > span {
    word-break: break-all;
    overflow-wrap: break-word;
    // 自由記述は本文 bold とは別の通常重みで表示する
    font-weight: normal;
  }
}
.who5 {
  li {
    justify-content: space-between;
  }
}
.assistant {
  font-size: 12px;
  color: var(--pink);
}
.textareaDiv {
  position: relative;

  .textarea {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: none;
    appearance: none;
    padding: 20px;
    outline: none;
    z-index:0;
    position: relative;
    resize: vertical;
    min-height: 170px;
    background-color: var(--gray-sub);
  }
  .placeholderDiv{
    border: none;
    // 背景がグレー塗り（--gray-sub）のため、従来のグレーではコントラスト比が約 2.5:1 で読みづらい。
    // 4.5:1 を満たす濃さへ変更する（値は ReserveFormWizard.vue の ::placeholder と揃える）。
    color: #6d6d6d;
    position: absolute;
    top: 0px;
    left: 0px;
    padding: 20px;
    font-size: 14px;
    z-index: 1;
    pointer-events:none;
    // 注釈が textarea より縦に長くても枠外へはみ出さない安全弁（あふれた分は見切れる）。
    // 収まる高さは textarea 側の rows で調整する。
    width: 100%;
    max-height: 100%;
    overflow: hidden;
  }
  // 報告書フォームの注釈欄。オーバーレイ機構はカルテ欄と共用するが、高さはカルテ用の
  // min-height ではなく欄ごとの rows で決める（現行の入力欄の高さを保つため）。
  // .textareaDiv .textarea より詳細度を 1 段高くして、記述順に依存せず打ち消す。
  &.noteField .textarea {
    min-height: 0;
  }
}
// 企業ユーザー時のみメイン項目を縦並びにする
.typesCompany {
  display: block;
}
// 企業サイト: メイン項目の下に「選択済み」サブ項目を ' / ' 連結で表示する。
// 表示形は予約入力の確認ステップ（ReserveFormWizard の確認欄）に合わせてある。
// span を block 化して親 <span> 内で改行させる。テンプレ側は1行で書くこと
// （親に white-space: pre-wrap が効く画面があり、改行・インデントが空白として可視化されるため）。
.subList {
  display: block;
  margin: 2px 0 8px 20px;
  font-size: 13px;
  color: #555;
}

</style>
